import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PackagePurchasesContent from "./PackagePurchasesContent";

const PackagePurchasesPage = () => (
  <PackagePurchasesContent
    type="paket"
    title={translate("analyticsPage.package.report_purchases")}
    backTo={PATHS.ANALYTICS}
  />
);

export default PackagePurchasesPage;
